(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('OfferStatusDialogController', OfferStatusDialogController);

    OfferStatusDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'OfferStatus'];

    function OfferStatusDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, OfferStatus) {
        var vm = this;
        vm.offerStatus = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:offerStatusUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.offerStatus.id !== null) {
                OfferStatus.update(vm.offerStatus, onSaveSuccess, onSaveError);
            } else {
                OfferStatus.save(vm.offerStatus, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
